import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const contactOptions = [
  {
    icon: <CallIcon sx={{ fontSize: 36 }} />,
    title: 'Call Sales',
    subtitle: 'Talk directly with our team',
    action: '+91 7904037932',
    color: '#050f66',
    bgColor: 'rgba(5, 15, 102, 0.07)',
    borderColor: 'rgba(5, 15, 102, 0.15)',
    onClick: () => window.open('tel:7904037932', '_blank'),
  },
  {
    icon: <WhatsAppIcon sx={{ fontSize: 36 }} />,
    title: 'WhatsApp',
    subtitle: 'Chat with us instantly',
    action: 'Open WhatsApp Chat',
    color: '#25d366',
    bgColor: 'rgba(37, 211, 102, 0.07)',
    borderColor: 'rgba(37, 211, 102, 0.25)',
    onClick: () =>
      window.open(
        'https://api.whatsapp.com/send/?phone=917904037932&text&app_absent=0',
        '_blank'
      ),
  },
  {
    icon: <EmailIcon sx={{ fontSize: 36 }} />,
    title: 'Email Us',
    subtitle: 'Send your enquiry',
    action: 'streamiswell@gmail.com',
    color: '#e53935',
    bgColor: 'rgba(229, 57, 53, 0.07)',
    borderColor: 'rgba(229, 57, 53, 0.18)',
    onClick: () =>
      window.open(
        'mailto:streamiswell@gmail.com&subject=Streamwell enquiry - Reg',
        '_blank'
      ),
  },
];

const ContactCard = ({ option }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      border: `1px solid ${option.borderColor}`,
      borderRadius: '20px',
      transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
      '&:hover': {
        transform: 'translateY(-6px)',
        boxShadow: `0 20px 50px ${option.bgColor.replace('0.07', '0.22')}`,
        borderColor: option.color,
        '& .contact-arrow': { opacity: 1, transform: 'translateX(0)' },
      },
    }}
  >
    <CardActionArea onClick={option.onClick} sx={{ height: '100%' }}>
      <CardContent sx={{ textAlign: 'center', py: { xs: 4, md: 5 }, px: 3 }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: option.bgColor,
            color: option.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}
        >
          {option.icon}
        </Box>
        <Typography
          component="h3"
          sx={{ fontWeight: 800, fontSize: '1.2rem', color: '#0d1757', mb: 0.8 }}
        >
          {option.title}
        </Typography>
        <Typography sx={{ color: '#9ca3af', fontSize: '0.9rem', mb: 2 }}>
          {option.subtitle}
        </Typography>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            color: option.color,
            fontWeight: 700,
            fontSize: '0.9rem',
          }}
        >
          {option.action}
          <ArrowForwardIcon
            className="contact-arrow"
            sx={{
              fontSize: 16,
              opacity: 0,
              transform: 'translateX(-6px)',
              transition: 'all 0.3s ease',
            }}
          />
        </Box>
      </CardContent>
    </CardActionArea>
  </Card>
);

const Aboutus = () => (
  <Box
    id="contact"
    sx={{
      background: '#ffffff',
      py: { xs: 8, md: 12 },
    }}
  >
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
        <Typography
          component="span"
          sx={{
            display: 'inline-block',
            background: 'rgba(5, 15, 102, 0.07)',
            color: '#050f66',
            fontWeight: 700,
            fontSize: '13px',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            px: 2,
            py: 0.8,
            borderRadius: '20px',
            mb: 2,
          }}
        >
          Contact Us
        </Typography>
        <Typography
          component="h2"
          sx={{
            color: '#0d1757',
            fontSize: { xs: '2rem', md: '2.8rem' },
            fontWeight: 800,
            mb: 2,
            lineHeight: 1.15,
          }}
        >
          Let's Get You Streaming
        </Typography>
        <Typography
          sx={{
            color: '#6b7280',
            fontSize: { xs: '1rem', md: '1.1rem' },
            maxWidth: '520px',
            mx: 'auto',
            lineHeight: 1.7,
          }}
        >
          Our team is ready to help you get started. Reach out through any channel — we respond
          fast.
        </Typography>
      </Box>

      <Grid container spacing={3} justifyContent="center">
        {contactOptions.map((option) => (
          <Grid item xs={12} sm={6} md={4} key={option.title}>
            <ContactCard option={option} />
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default Aboutus;
